export default function WorkHero() {
  return (
    <section className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <p className="text-yellow-400 uppercase tracking-wider text-sm font-semibold mb-4">
          Portfolio
        </p>
        <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: 'Oswald, sans-serif' }}>
          Our Recent Work
        </h1>
        <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
          See the quality and professionalism we bring to every parking lot project across Oklahoma City
        </p>
      </div>
    </section>
  );
}
